// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__AK0RI","pageItem":"Pagination_pageItem__VDrvA","selected":"Pagination_selected__TEMwI","info":"Pagination_info__B+-t+"};